import "media-chrome";
import "hls-video-element";

export default function hlsVideo() {
	return {
		init() {
			// console.log(this.$root);
		},
	};
}
